<template>
  <div class="m-list" v-gxxt-loading="isLoadingMore">
    <ul>
      <li v-for="(item, index) in list.records" :key="index">
        <div class="c-title">完成「 {{item.name}}」{{constants.gradeType[item.type]}}</div>
        <div class="c-info">
          <div class="c-time">{{formatDate(item.ct, 'yyyy-MM-dd')}}</div>
          <div class="c-grade">+{{item.grade}}学分</div>
        </div>
      </li>
    </ul>
    <gxxt-no-data v-if="!isLoadingMore && list.records.length==0" text="多加学习可以获得学分哦～"></gxxt-no-data>
  </div>
</template>

<script>
import {
  getAppScrollTop,
  getAppScrollHeight,
  getWindowHeight,
} from '@/utils/common'
import dates from '@/utils/dates'
import { GxxtNoData } from '@/components'
export default {
  components: {
    GxxtNoData,
  },
  data() {
    return {
      list: { records: [] },
      isLoadingMore: false,
      nodata: false,
      more: true,
      beforeScrollTop: 0,
    }
  },
  unmounted() {
    this.removeScroll()
  },
  mounted() {
    this.trainCampId = this.$route.query.trainCampId
    this.getMyGradeRecord()
    this.bindScroll()
  },
  methods: {
    formatDate(ct, format) {
      return dates.formatDate(ct, format)
    },
    async getMyGradeRecord({ more = false } = {}) {
      if (more && !this.more) return
      this.isLoadingMore = true
      let res = await this.api.my.getMyGradeRecord({
        pageSize: 15,
        pageNum: more ? this.list.pageNum + 1 : 1,
        trainCampId: this.trainCampId,
      })
      if (res && res.code == 200) {
        if (more) {
          res.data.records.forEach((item) => {
            this.list.records.push(item)
          })
          this.list.pageNum = res.data.pageNum
        } else {
          if (
            Object.prototype.toString.call(res.data.records) !=
              '[object Array]' ||
            res.data.records.length == 0
          ) {
            this.nodata = true
          } else {
            this.nodata = false
          }
          if (
            Object.prototype.toString.call(res.data.records) == '[object Array]'
          ) {
            this.list = res.data
          }
        }
        if (res.data.totalPage == res.data.pageNum) {
          this.more = false
        }
        console.log(this.more)
      }
      this.isLoadingMore = false
    },
    bindScroll() {
      document.getElementById('app').addEventListener('scroll', this.scrollFun)
    },
    removeScroll() {
      this.isLoadingMore = false
      document
        .getElementById('app')
        .removeEventListener('scroll', this.scrollFun)
    },
    scrollFun() {
      let timeAction
      if (this.isLoadingMore) {
        return
      }
      const callback = () => {
        var scrollTop = getAppScrollTop(),
          delta = scrollTop - this.beforeScrollTop
        this.beforeScrollTop = scrollTop
        if (
          delta > 0 &&
          scrollTop + getWindowHeight() + 100 > getAppScrollHeight()
        ) {
          this.loadMoreFn()
        }
      }
      if (timeAction) {
        clearTimeout(timeAction)
      }
      timeAction = setTimeout(callback, 50)
    },
    loadMoreFn() {
      if (this.isLoadingMore || !this.more) {
        return false
      }
      this.getMyGradeRecord({ more: true })
    },
  },
}
</script>

<style lang="less" scoped>
.m-list {
  padding: 0 32px;
  li {
    padding: 35px 0 30px;
    border-bottom: 2px solid #dedede;
  }
  .c-title {
    font-size: 28px;
    font-weight: 500;
    color: #333333;
    line-height: 38px;
    padding-bottom: 13px;
    text-align: left;
  }
  .c-info {
    display: flex;
    justify-content: space-between;
  }
  .c-time {
    font-size: 26px;
    font-weight: 400;
    color: #666666;
    line-height: 1;
  }
  .c-grade {
    font-size: 30px;
    font-weight: 500;
    color: #ff5500;
    line-height: 1;
  }
}
</style>